import Link from "next/link"
import Image from "next/image"
import track from "utilities/track"
import DynamicVideo from "components/DynamicVideo"
import CallToAction from "components/CallToAction"
import Icon from "public/assets/icon.svg"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function SmallArticleCard({ video, category, cta_text, link, description, image, title }) {
  return (
    <div className="flex flex-col shadow-lg max-w-xl mx-auto">
      {video.id !== "" ? (
        <div>
          <DynamicVideo component={video.component} image={image} {...video} title={title} />
        </div>
      ) : (
        <Link
          href={getStoryblokLink(link)}
          onClick={() => track({ event: "click_more_article_button", options: { article: title } })}
        >
          <Image
            src={image.filename}
            height={300}
            className="aspect-video object-cover"
            width={400}
            style={{ width: "100%", height: "auto" }}
            alt={image.alt}
          />
        </Link>
      )}

      <div className="bg-white h-full min-h-[350px] p-8 lg:relative">
        <Icon className="hidden lg:block absolute bottom-0 right-0" />
        <Link
          href={getStoryblokLink(link)}
          onClick={() => track({ event: "click_more_article_button", options: { article: title } })}
        >
          <h3>{title}</h3>
        </Link>
        <div className="py-4">{description}</div>
        <CallToAction
          style="secondary"
          href={getStoryblokLink(link)}
          target="_blank"
          onClick={() => track({ event: "click_more_article_button", options: { article: title } })}
        >
          {cta_text}
        </CallToAction>
      </div>
    </div>
  )
}
